import PageHero from "../components/PageHero";
import Services from "../components/sections/Services";
import SiteVisitCTA from "../components/sections/SiteVisitCTA";

export default function ServicesPage({ onOpenLead }) {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="What We Do"
        title="End-to-end real estate advisory."
        subtitle="From investment strategy to documentation — a single trusted partner for every step of your real estate journey."
        image="https://images.pexels.com/photos/18285887/pexels-photo-18285887.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      />
      <Services onOpenLead={onOpenLead} />
      <SiteVisitCTA />
    </div>
  );
}
